import { render, staticRenderFns } from "./expertList.vue?vue&type=template&id=0c384b3f&scoped=true"
import script from "./expertList.vue?vue&type=script&lang=js"
export * from "./expertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c384b3f",
  null
  
)

export default component.exports